import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import IcNewNpayLogo from '../icons/IcNewNpayLogo.js';
import IcNewNpayN from '../icons/IcNewNpayN.js';
import IcNewNpayPay from '../icons/IcNewNpayPay.js';
import { NAVER_MAIN_URL } from '../../constants/url.js';
import { GlobalConfig } from '../../globalConfig.js';
import { isProduction } from '../../utils/env.js';
import styles from './HeaderNpayButton.module.scss.js';

var _excluded = ["href"],
  _excluded2 = ["href"],
  _excluded3 = ["isPayApp", "href"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var DEFAULT_ATTRS = {
  href: ''
};
function HeaderNpayButton(_ref) {
  var n = _ref.n,
    pay = _ref.pay,
    isMobile = _ref.isMobile,
    isPayApp = _ref.isPayApp;
  var _ref2 = n || DEFAULT_ATTRS,
    nHref = _ref2.href,
    nProps = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = pay || DEFAULT_ATTRS,
    payHref = _ref3.href,
    payProps = _objectWithoutProperties(_ref3, _excluded2);
  var nLink = nHref || NAVER_MAIN_URL[isMobile ? 'MOBILE' : 'PC'];
  var myDataHomeHref = "".concat(GlobalConfig.payDomain, "/mydata/home");
  return /*#__PURE__*/React.createElement(React.Fragment, null, isPayApp ? ( /*#__PURE__*/React.createElement(HeaderNPayMonoButton, {
    isPayApp: isPayApp
  })) : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, nProps), {}, {
    href: nLink,
    className: cx('link')
  }), /*#__PURE__*/React.createElement(IcNewNpayN, {
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB124\uC774\uBC84")), /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, payProps), {}, {
    href: payHref || myDataHomeHref,
    className: cx('link')
  }), /*#__PURE__*/React.createElement(IcNewNpayPay, {
    width: 39,
    height: 22
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB124\uC774\uBC84 \uD398\uC774")))));
}
function HeaderNPayMonoButton(_ref4) {
  var isPayApp = _ref4.isPayApp,
    href = _ref4.href,
    props = _objectWithoutProperties(_ref4, _excluded3);
  /**
   * 페이앱 환경에서 N Pay 클릭 시 페이 메인(결제 페이지)로 이동
   * @see https://pages.oss.navercorp.com/techFin/payapp-docs/naverpay/webinterface/payinappbrowser/payinappbrowser/#payInAppBrowser.showServiceMenu
   * @see https://oss.fin.navercorp.com/Product-Planning/DeFign_Plan/issues/635
   */
  function handleClickNPayInPayApp(e) {
    var _window$payInAppBrows;
    e.preventDefault();
    if ((_window$payInAppBrows = window.payInAppBrowser) !== null && _window$payInAppBrows !== void 0 && _window$payInAppBrows.showServiceMenu) {
      var _window$payInAppBrows2, _window$payInAppBrows3;
      (_window$payInAppBrows2 = (_window$payInAppBrows3 = window.payInAppBrowser).showServiceMenu) === null || _window$payInAppBrows2 === void 0 || _window$payInAppBrows2.call(_window$payInAppBrows3, '{"menuName": "payment", "subMenuName": "pay"}');
    } else {
      // eslint-disable-next-line no-console
      !isProduction && console.warn('payInAppBrowser 의 showServiceMenu 앱 인터페이스 미제공 환경입니다.');
    }
  }
  var myDataHomeHref = "".concat(GlobalConfig.payDomain, "/mydata/home");
  return /*#__PURE__*/React.createElement(React.Fragment, null, isPayApp ? ( /*#__PURE__*/React.createElement("a", {
    href: GlobalConfig.payDomain,
    className: cx('link'),
    onClick: handleClickNPayInPayApp
  }, /*#__PURE__*/React.createElement(IcNewNpayLogo, {
    width: 66,
    height: 22
  }))) : ( /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, props), {}, {
    href: href || myDataHomeHref,
    className: cx('link')
  }), /*#__PURE__*/React.createElement(IcNewNpayLogo, {
    width: 66,
    height: 22
  }))));
}

export { HeaderNPayMonoButton, HeaderNpayButton };
